import { Link } from "react-router-dom";
import { Clock, Lock, Sparkles } from "lucide-react";
import { useEntitlements } from "../lib/entitlements";

/** Top-center trial countdown badge. Auto-adapts to show h/m in the final day. */
export default function TrialBanner() {
  const { status } = useEntitlements();
  if (!status) return null;

  if (status.trial_active) {
    const d = status.days_left;
    const h = status.hours_left;
    const m = status.minutes_left;
    let label;
    if (d >= 1) label = `Tu prueba termina en ${d} día${d === 1 ? "" : "s"}`;
    else label = `Tu prueba termina en ${h} h ${m} min`;
    const urgent = d <= 1;
    return (
      <Link
        to="/pricing"
        className={`trial-banner${urgent ? " urgent" : ""}`}
        data-testid="trial-banner"
      >
        <Clock size={14} />
        <b>⏳ {label}</b>
        <span>Elegir plan →</span>
      </Link>
    );
  }

  if (status.trial_expired && !status.is_paid) {
    return (
      <Link to="/trial-expired" className="trial-banner urgent" data-testid="trial-expired-banner">
        <Lock size={14} />
        <b>Tu prueba terminó · tus datos están a salvo</b>
        <span>Ver planes →</span>
      </Link>
    );
  }

  return null;
}
